{
  "title": "Détails de l'Évaluation",
  "description": "Voir les informations détaillées sur cette évaluation",
  "backToPatient": "Retour au Patient",
  "notFound": "Évaluation introuvable",
  "notFoundDescription": "L'évaluation que vous recherchez n'existe pas ou a été supprimée",
  "evaluationInfo": "Informations de l'Évaluation",
  "evaluationInfoDescription": "Informations générales sur cette évaluation",
  "patientInfo": "Informations du Patient",
  "category": "Catégorie",
  "status": "Statut",
  "duration": "Durée",
  "createdAt": "Créé le",
  "updatedAt": "Dernière mise à jour",
  "notCompleted": "Non terminé",
  "patientName": "Nom du Patient",
  "patientEmail": "Email",
  "patientBirthDate": "Date de Naissance",
  "notes": "Notes",
  "evaluationData": "Données de l'Évaluation",
  "evaluationDataDescription": "Résultats détaillés de l'évaluation et analyse",
  "detailedDataComingSoon": "Visualisation détaillée des données d'évaluation bientôt disponible",
  "startedAt": "Commencé le",
  "endedAt": "Terminé le",
  "admin": {
    "title": "Évaluations",
    "description": "Gérer les modules d'évaluation, catégories, échelles et questions pour les évaluations",
    "tabs": {
      "modules": "Modules",
      "scales": "Échelles"
    },
    "common": {
      "cancel": "Annuler",
      "save": "Enregistrer",
      "create": "Créer",
      "update": "Mettre à jour",
      "delete": "Supprimer",
      "edit": "Modifier",
      "view": "Voir",
      "add": "Ajouter",
      "loading": "Chargement...",
      "creating": "Création...",
      "updating": "Mise à jour...",
      "deleting": "Suppression...",
      "searchPlaceholder": "Rechercher...",
      "noResults": "Aucun résultat trouvé",
      "noResultsSearch": "Aucun résultat trouvé correspondant à votre recherche",
      "actions": "Actions",
      "active": "Actif",
      "inactive": "Inactif",
      "created": "Créé",
      "order": "Ordre",
      "selectOption": "Sélectionner une option",
      "openMenu": "Ouvrir le menu"
    },
    "modules": {
      "title": "Modifier le Module",
      "description": "Mettre à jour les informations et paramètres du module.",
      "addTitle": "Ajouter un Nouveau Module",
      "addDescription": "Créer un nouveau module d'évaluation avec catégories et questions.",
      "editTitle": "Modifier le Module",
      "editDescription": "Mettre à jour les informations et paramètres du module.",
      "viewTitle": "Détails du Module",
      "deleteTitle": "Supprimer le Module",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer ce module ?",
      "deleteConfirm": "Cette action ne peut pas être annulée et supprimera toutes les catégories et questions associées.",
      "searchPlaceholder": "Rechercher des modules...",
      "createFirst": "Veuillez d'abord créer un module pour gérer les questions.",
      "form": {
        "title": "Titre",
        "titlePlaceholder": "Entrer le titre du module",
        "code": "Code",
        "codePlaceholder": "CODE_MODULE",
        "description": "Description",
        "descriptionPlaceholder": "Entrer la description du module",
        "image": "Image (Optionnel)",
        "imagePlaceholder": "Uploader une image",
        "isActive": "Actif",
        "isActiveDescription": "Activer ce module pour les évaluations"
      },
      "deleteDialogTitle": "Supprimer le Module",
      "deleteDialogDescription": "Êtes-vous sûr de vouloir supprimer \"{{title}}\" ? Cette action ne peut pas être annulée et supprimera toutes les catégories et questions associées.",
      "deleteButton": "Supprimer le Module",
      "deletingButton": "Suppression...",
      "deleteSuccessMessage": "Module supprimé avec succès",
      "deleteErrorMessage": "Échec de la suppression du module",
      "updateSuccessMessage": "Module mis à jour avec succès",
      "updateErrorMessage": "Échec de la mise à jour du module",
      "createSuccessMessage": "Module créé avec succès",
      "createErrorMessage": "Échec de la création du module",
      "table": {
        "searchPlaceholder": "Rechercher des modules...",
        "addButton": "Ajouter un Module",
        "headers": {
          "title": "Titre",
          "code": "Code",
          "categories": "Catégories",
          "questions": "Questions",
          "status": "Statut",
          "created": "Créé",
          "actions": "Actions"
        },
        "loading": "Chargement des modules...",
        "noResults": "Aucun module trouvé.",
        "noResultsSearch": "Aucun module trouvé correspondant à votre recherche.",
        "status": {
          "active": "Actif",
          "inactive": "Inactif"
        }
      }
    },
    "scales": {
      "title": "Échelles d'Évaluation",
      "description": "Gérer les échelles de notation avec des options et valeurs personnalisées",
      "addTitle": "Ajouter une Nouvelle Échelle",
      "addDescription": "Créer une nouvelle échelle d'évaluation avec des options et valeurs personnalisées.",
      "editTitle": "Modifier l'Échelle",
      "editDescription": "Mettre à jour les informations et options de l'échelle.",
      "viewTitle": "Détails de l'Échelle",
      "deleteTitle": "Supprimer l'Échelle",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette échelle ?",
      "deleteConfirm": "Cette action ne peut pas être annulée et affectera toutes les questions utilisant cette échelle.",
      "searchPlaceholder": "Rechercher des échelles...",
      "comingSoon": "Interface de gestion des échelles bientôt disponible...",
      "form": {
        "label": "Libellé de l'Échelle",
        "labelPlaceholder": "Entrer le libellé de l'échelle",
        "code": "Code de l'Échelle",
        "codePlaceholder": "CODE_ECHELLE",
        "options": "Options de l'Échelle",
        "optionLabel": "Libellé",
        "optionValue": "Valeur",
        "optionLabelPlaceholder": "Libellé de l'option",
        "optionValuePlaceholder": "0",
        "addOption": "Ajouter une Option",
        "preview": "Aperçu :",
        "uniqueValuesError": "Toutes les valeurs d'option doivent être uniques",
        "defaultOptions": {
          "poor": "Faible",
          "fair": "Correct",
          "good": "Bon",
          "excellent": "Excellent"
        },
        "optionLabelLabel": "Libellé",
        "optionValueLabel": "Valeur",
        "addOptionButton": "Ajouter une Option",
        "previewLabel": "Aperçu :",
        "uniqueValuesErrorMessage": "Toutes les valeurs d'option doivent être uniques"
      },
      "createSuccessMessage": "Échelle créée avec succès",
      "createErrorMessage": "Échec de la création de l'échelle",
      "table": {
        "searchPlaceholder": "Rechercher des échelles...",
        "addButton": "Ajouter une Échelle",
        "headers": {
          "label": "Libellé",
          "code": "Code",
          "options": "Options",
          "questions": "Questions",
          "created": "Créé",
          "actions": "Actions"
        },
        "loading": "Chargement des échelles...",
        "noResults": "Aucune échelle trouvée.",
        "noResultsSearch": "Aucune échelle trouvée correspondant à votre recherche.",
        "option": "Option {{index}}",
        "more": "+{{count}} plus"
      },
      "viewDescription": "Voir les informations et options de l'échelle.",
      "deleteDialogTitle": "Supprimer l'Échelle",
      "deleteDialogDescription": "Êtes-vous sûr de vouloir supprimer \"{{label}}\" ? Cette action ne peut pas être annulée et affectera toutes les questions utilisant cette échelle.",
      "deleteButton": "Supprimer l'Échelle",
      "deletingButton": "Suppression...",
      "deleteSuccessMessage": "Échelle supprimée avec succès",
      "deleteErrorMessage": "Échec de la suppression de l'échelle",
      "updateSuccessMessage": "Échelle mise à jour avec succès",
      "updateErrorMessage": "Échec de la mise à jour de l'échelle"
    },
    "questions": {
      "title": "Questions d'Évaluation",
      "description": "Gérer les questions avec réorganisation par glisser-déposer et codes auto-générés",
      "addTitle": "Ajouter une Nouvelle Question",
      "addDescription": "Créer une nouvelle question avec code auto-généré.",
      "editTitle": "Modifier la Question",
      "editDescription": "Mettre à jour les informations et paramètres de la question.",
      "viewTitle": "Détails de la Question",
      "deleteTitle": "Supprimer la Question",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette question ?",
      "deleteConfirm": "Cette action ne peut pas être annulée.",
      "searchPlaceholder": "Rechercher des questions...",
      "groupedBy": "Questions groupées par catégorie :",
      "categories": "catégories",
      "form": {
        "question": "Question",
        "questionPlaceholder": "Entrer le texte de la question",
        "hint": "Indice (Optionnel)",
        "hintPlaceholder": "Entrer un indice utile",
        "category": "Catégorie",
        "scale": "Échelle",
        "code": "Code de la Question",
        "orderIndex": "Ordre"
      },
      "table": {
        "searchPlaceholder": "Rechercher des questions...",
        "addButton": "Ajouter une Question",
        "headers": {
          "question": "Question",
          "category": "Catégorie",
          "scale": "Échelle",
          "order": "Ordre",
          "created": "Créé",
          "actions": "Actions"
        },
        "loading": "Chargement des questions...",
        "noResults": "Aucune question trouvée.",
        "noResultsSearch": "Aucune question trouvée correspondant à votre recherche.",
        "groupedBy": "Questions groupées par catégorie :",
        "categories": "catégories"
      },
      "viewDescription": "Voir les informations et paramètres de la question.",
      "deleteDialogTitle": "Supprimer la Question",
      "deleteDialogDescription": "Êtes-vous sûr de vouloir supprimer cette question ? Cette action ne peut pas être annulée.",
      "deleteButton": "Supprimer la Question",
      "deletingButton": "Suppression...",
      "deleteSuccessMessage": "Question supprimée avec succès",
      "deleteErrorMessage": "Échec de la suppression de la question",
      "updateSuccessMessage": "Question mise à jour avec succès",
      "updateErrorMessage": "Échec de la mise à jour de la question",
      "createSuccessMessage": "Question créée avec succès",
      "createErrorMessage": "Échec de la création de la question"
    },
    "categories": {
      "title": "Catégories",
      "description": "Gérer les catégories hiérarchiques avec des structures de chemin arborescentes",
      "addTitle": "Ajouter une Nouvelle Catégorie",
      "addDescription": "Créer une nouvelle catégorie avec une structure de chemin hiérarchique.",
      "editTitle": "Modifier la Catégorie",
      "editDescription": "Mettre à jour les informations et la structure de chemin de la catégorie.",
      "viewTitle": "Détails de la Catégorie",
      "deleteTitle": "Supprimer la Catégorie",
      "deleteDescription": "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
      "deleteConfirm": "Cette action ne peut pas être annulée et supprimera toutes les questions associées.",
      "searchPlaceholder": "Rechercher des catégories...",
      "form": {
        "label": "Libellé de la Catégorie",
        "labelPlaceholder": "Entrer le libellé de la catégorie",
        "parent": "Catégorie Parente",
        "parentPlaceholder": "Sélectionner une catégorie parente...",
        "slug": "Identifiant",
        "slugPlaceholder": "identifiant-de-la-categorie",
        "pathSegments": "Chemin de la Catégorie",
        "pathPlaceholder": "Entrer le segment de chemin",
        "pathPreview": "Aperçu du Chemin Complet :",
        "path": "Chemin",
        "depth": "Profondeur :",
        "addLevel": "Ajouter un Niveau",
        "isActive": "Actif",
        "isActiveDescription": "Activer cette catégorie pour les évaluations",
        "depthLabel": "Profondeur :",
        "pathPreviewTitle": "Aperçu du Chemin Complet :",
        "rootLevel": "Niveau racine"
      },
      "createSuccessMessage": "Catégorie créée avec succès",
      "createErrorMessage": "Échec de la création de la catégorie",
      "table": {
        "searchPlaceholder": "Rechercher des catégories...",
        "addButton": "Ajouter une Catégorie",
        "headers": {
          "label": "Libellé",
          "path": "Chemin",
          "depth": "Profondeur",
          "questions": "Questions",
          "status": "Statut",
          "created": "Créé",
          "actions": "Actions"
        },
        "loading": "Chargement des catégories...",
        "noResults": "Aucune catégorie trouvée.",
        "noResultsSearch": "Aucune catégorie trouvée correspondant à votre recherche.",
        "status": {
          "active": "Actif",
          "inactive": "Inactif"
        }
      },
      "viewDescription": "Voir les informations et statistiques de la catégorie.",
      "deleteDialogTitle": "Supprimer la Catégorie",
      "deleteDialogDescription": "Êtes-vous sûr de vouloir supprimer \"{{label}}\" ? Cette action ne peut pas être annulée et supprimera toutes les questions associées.",
      "deleteButton": "Supprimer la Catégorie",
      "deletingButton": "Suppression...",
      "deleteSuccessMessage": "Catégorie supprimée avec succès",
      "deleteErrorMessage": "Échec de la suppression de la catégorie",
      "updateSuccessMessage": "Catégorie mise à jour avec succès",
      "updateErrorMessage": "Échec de la mise à jour de la catégorie"
    },
    "recommendations": {
      "title": "Recommandations",
      "description": "Gérer les recommandations pour différentes catégories et modalités",
      "add": "Ajouter une Recommandation",
      "edit": "Modifier la Recommandation",
      "view": "Voir la Recommandation",
      "delete": "Supprimer la Recommandation",
      "loading": "Chargement des recommandations...",
      "searchPlaceholder": "Rechercher par catégorie ou modalité...",
      "foundResults": "{{count}} recommandation(s) trouvée(s)",
      "noResults": "Aucune recommandation trouvée",
      "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette recommandation ?",
      "deleteWarning": "Cette action ne peut pas être annulée.",
      "fields": {
        "category": "Catégorie",
        "modality": "Modalité",
        "shortContent": "Contenu Court",
        "deepContent": "Contenu Détaillé",
        "thresholdMin": "Seuil Minimum",
        "thresholdMax": "Seuil Maximum"
      },
      "placeholders": {
        "selectCategory": "Sélectionner une catégorie",
        "shortContent": "Saisir le contenu court de la recommandation",
        "deepContent": "Saisir le contenu détaillé de la recommandation",
        "thresholdMin": "Valeur du seuil minimum",
        "thresholdMax": "Valeur du seuil maximum"
      },
      "actions": {
        "save": "Enregistrer",
        "cancel": "Annuler",
        "delete": "Supprimer",
        "close": "Fermer"
      },
      "table": {
        "category": "Catégorie",
        "modality": "Modalité",
        "shortContent": "Contenu Court",
        "thresholds": "Seuils",
        "actions": "Actions",
        "min": "Min",
        "max": "Max"
      },
      "addSheetDescription": "Créer une nouvelle recommandation pour une catégorie et une modalité spécifiques.",
      "editSheetDescription": "Mettez à jour les détails de la recommandation ci-dessous.",
      "viewSheetDescription": "Voir les détails et le contenu de la recommandation.",
      "idLabel": "ID",
      "messages": {
        "createSuccess": "Recommandation créée avec succès",
        "updateSuccess": "Recommandation mise à jour avec succès",
        "deleteSuccess": "Recommandation supprimée avec succès",
        "createError": "Erreur lors de la création de la recommandation",
        "updateError": "Erreur lors de la mise à jour de la recommandation",
        "deleteError": "Erreur lors de la suppression de la recommandation"
      }
    },
    "moduleView": {
      "title": "Détails du Module",
      "description": "Détails et statistiques du module",
      "fields": {
        "code": "Code",
        "description": "Description",
        "status": "Statut",
        "categories": "Catégories",
        "questions": "Questions",
        "created": "Créé",
        "image": "Image"
      },
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      }
    },
    "moduleDetails": {
      "title": "Détails du Module",
      "description": "Gérer les catégories, questions et recommandations pour ce module d'évaluation",
      "breadcrumb": {
        "evaluations": "Évaluations",
        "moduleDetails": "Détails du Module"
      },
      "sections": {
        "overview": "Aperçu",
        "categories": "Catégories",
        "questions": "Questions et Recommandations"
      },
      "overview": {
        "title": "Informations du Module",
        "fields": {
          "code": "Code",
          "description": "Description",
          "status": "Statut",
          "created": "Créé",
          "image": "Image",
          "totalCategories": "Total des Catégories",
          "totalQuestions": "Total des Questions"
        },
        "status": {
          "active": "Actif",
          "inactive": "Inactif"
        },
        "actions": {
          "edit": "Modifier le Module",
          "viewQuestions": "Voir Toutes les Questions"
        }
      },
      "categories": {
        "title": "Catégories",
        "description": "Cliquez sur une catégorie pour voir ses questions et recommandations",
        "addCategory": "Ajouter une Catégorie",
        "noCategories": "Aucune catégorie trouvée pour ce module",
        "createFirst": "Créez votre première catégorie pour organiser les questions",
        "card": {
          "questions": "questions",
          "recommendations": "recommandations",
          "depth": "Profondeur {{depth}}",
          "path": "Chemin : {{path}}",
          "inactive": "Inactif"
        }
      },
      "questions": {
        "title": "Questions et Recommandations",
        "description": "Gérer les questions et recommandations avec recherche et filtrage avancés",
        "filterByCategory": "Filtrer par Catégorie",
        "allCategories": "Toutes les Catégories",
        "tabQuestions": "Questions",
        "tabRecommendations": "Recommandations",
        "noQuestions": "Aucune question trouvée pour cette catégorie",
        "addQuestion": "Ajouter une Question",
        "categoryRecommendations": "Recommandations pour {{categoryName}}",
        "noRecommendations": "Aucune recommandation trouvée pour cette catégorie",
        "addRecommendation": "Ajouter une Recommandation"
      },
      "actions": {
        "back": "Retour aux Évaluations",
        "edit": "Modifier",
        "view": "Voir",
        "delete": "Supprimer",
        "add": "Ajouter"
      }
    }
  },
  "success": {
    "createCategorySuccess": "Catégorie créée avec succès",
    "createCategorySuccessDescription": "La catégorie a été ajoutée au module",
    "createModuleSuccess": "Module créé avec succès",
    "createModuleSuccessDescription": "Le module a été ajouté à votre liste",
    "createQuestionSuccess": "Question créée avec succès",
    "createQuestionSuccessDescription": "La question a été ajoutée à la catégorie",
    "createRecommendationSuccess": "Recommandation créée avec succès",
    "createRecommendationSuccessDescription": "La nouvelle recommandation a été ajoutée",
    "createScaleSuccess": "Échelle créée avec succès",
    "createScaleSuccessDescription": "L'échelle est désormais disponible globalement",
    "deleteCategorySuccess": "Catégorie supprimée avec succès",
    "deleteModuleSuccess": "Module supprimé avec succès",
    "deleteQuestionSuccess": "Question supprimée avec succès",
    "deleteRecommendationSuccess": "Recommandation supprimée avec succès",
    "deleteScaleSuccess": "Échelle supprimée avec succès",
    "reorderQuestionsSuccess": "Questions réorganisées avec succès",
    "updateCategorySuccess": "Catégorie mise à jour avec succès",
    "updateModuleSuccess": "Module mis à jour avec succès",
    "updateQuestionSuccess": "Question mise à jour avec succès",
    "updateRecommendationSuccess": "Recommandation mise à jour avec succès",
    "updateScaleSuccess": "Échelle mise à jour avec succès",
    "changesSaved": "Les modifications ont été enregistrées"
  },
  "errors": {
    "createCategoryFailed": "Échec de la création de la catégorie",
    "createModuleFailed": "Échec de la création du module",
    "createQuestionFailed": "Échec de la création de la question",
    "createRecommendationFailed": "Échec de la création de la recommandation",
    "createScaleFailed": "Échec de la création de l'échelle",
    "deleteCategoryFailed": "Échec de la suppression de la catégorie",
    "deleteModuleFailed": "Échec de la suppression du module",
    "deleteQuestionFailed": "Échec de la suppression de la question",
    "deleteRecommendationFailed": "Échec de la suppression de la recommandation",
    "deleteScaleFailed": "Échec de la suppression de l'échelle",
    "loadCategoriesTreeFailed": "Échec du chargement de l'arbre des catégories",
    "loadCategoriesFailed": "Échec du chargement des catégories",
    "getEvaluationDetailsFailed": "Échec du chargement des détails de l'évaluation",
    "getEvaluationsFailed": "Échec du chargement des évaluations",
    "loadModuleFailed": "Échec du chargement du module",
    "loadModulesFailed": "Échec du chargement des modules",
    "loadMonthlyCountFailed": "Échec du chargement du nombre mensuel d'évaluations",
    "loadQuestionFailed": "Échec du chargement de la question",
    "loadQuestionsFailed": "Échec du chargement des questions",
    "loadRecommendationsFailed": "Échec du chargement des recommandations",
    "loadScaleFailed": "Échec du chargement de l'échelle",
    "loadScalesFailed": "Échec du chargement des échelles",
    "reorderQuestionsFailed": "Échec de la réorganisation des questions",
    "updateCategoryFailed": "Échec de la mise à jour de la catégorie",
    "updateModuleFailed": "Échec de la mise à jour du module",
    "updateQuestionFailed": "Échec de la mise à jour de la question",
    "updateRecommendationFailed": "Échec de la mise à jour de la recommandation",
    "updateScaleFailed": "Échec de la mise à jour de l'échelle",
    "checkInfoAndRetry": "Veuillez vérifier vos informations et réessayer",
    "tryAgainLater": "Veuillez réessayer plus tard",
    "tryRefreshing": "Veuillez rafraîchir la page"
  }
}
